// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InternalendpointsModelSummary
 */
export interface InternalendpointsModelSummary {
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  auraInstanceId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  consoleUserId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  databaseUsername?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  projectId?: string;
  /**
   * PRIVATE / PROJECT
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  publishState?: string;
  /**
   *
   * @type {number}
   * @memberof InternalendpointsModelSummary
   */
  sizeInBytes?: number;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsModelSummary
   */
  storageLocation?: string;
}

/**
 * Check if a given object implements the InternalendpointsModelSummary interface.
 */
export function instanceOfInternalendpointsModelSummary(
  value: object,
): value is InternalendpointsModelSummary {
  return true;
}

export function InternalendpointsModelSummaryFromJSON(
  json: any,
): InternalendpointsModelSummary {
  return InternalendpointsModelSummaryFromJSONTyped(json, false);
}

export function InternalendpointsModelSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsModelSummary {
  if (json == null) {
    return json;
  }
  return {
    auraInstanceId:
      json['aura_instance_id'] == null ? undefined : json['aura_instance_id'],
    consoleUserId:
      json['console_user_id'] == null ? undefined : json['console_user_id'],
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    databaseUsername:
      json['database_username'] == null ? undefined : json['database_username'],
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    projectId: json['project_id'] == null ? undefined : json['project_id'],
    publishState:
      json['publish_state'] == null ? undefined : json['publish_state'],
    sizeInBytes:
      json['size_in_bytes'] == null ? undefined : json['size_in_bytes'],
    storageLocation:
      json['storage_location'] == null ? undefined : json['storage_location'],
  };
}

export function InternalendpointsModelSummaryToJSON(
  json: any,
): InternalendpointsModelSummary {
  return InternalendpointsModelSummaryToJSONTyped(json, false);
}

export function InternalendpointsModelSummaryToJSONTyped(
  value?: InternalendpointsModelSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aura_instance_id: value['auraInstanceId'],
    console_user_id: value['consoleUserId'],
    created_at: value['createdAt'],
    database_username: value['databaseUsername'],
    id: value['id'],
    name: value['name'],
    project_id: value['projectId'],
    publish_state: value['publishState'],
    size_in_bytes: value['sizeInBytes'],
    storage_location: value['storageLocation'],
  };
}
